import { PackageSessionResponse } from '~/types/api';
import staysStyles from '~/styles/bookingFlow/stays.module.css';
import Stay from './Stay';

type Props = {
  stays: PackageSessionResponse['poststays'] | PackageSessionResponse['prestays'];
  onUpdateStaySelected: (packageId: number, selected: boolean) => void;
};

export default function Stays({
  stays,
  onUpdateStaySelected,
}: Props) {
  if (stays.length === 0) {
    return null;
  }

  return (
    <div className={staysStyles.stays}>
      <div className={staysStyles.staysContent}>
        {stays.map((stay) => {
          return (
            <Stay
              key={stay.package_id}
              stay={stay}
              onChange={onUpdateStaySelected}
            />
          );
        })}
      </div>
    </div>
  );
}
